"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.XlsxPageUploader = XlsxPageUploader;
const React = __importStar(require("react"));
const xlsx_1 = require("xlsx");
const FileUpload = __importStar(require("../file-upload"));
function XlsxPageUploader(props) {
    return (React.createElement(FileUpload.FileUploadContainer, { onFileUploaded: createParseFile(props.onParsed), children: props.children, accept: ".xlsx" }));
}
function createParseFile(onParsed) {
    return (file) => parseXlsx(file, onParsed);
}
function parseXlsx(file, onParsed) {
    const fileReader = new FileReader();
    fileReader.onload = evt => {
        const textResult = evt.target.result;
        const workbook = (0, xlsx_1.read)(textResult, { type: "binary" });
        const data = parseWorkbook(workbook);
        onParsed(data);
    };
    fileReader.readAsBinaryString(file);
}
function parseWorksheet(sheet) {
    const json = xlsx_1.utils.sheet_to_json(sheet, { header: 1, defval: "" });
    return json.map((r) => r.map((c) => c.toString()));
}
function parseWorkbook(workbook) {
    return workbook.SheetNames.map(s => parseWorksheet(workbook.Sheets[s]));
}
//# sourceMappingURL=xlsx-page-uploader.js.map